export default __webpack_public_path__ + "static/media/cert4.3f80e3ea.jpg";